import {useTranslation} from "react-i18next";
import {IconClockTable} from "../../../../../components/buttons/IconButtons";
import CustomDaySelector from "../../../../../components/CustomDaySelector";
import { colors } from '../../../../../enums/colors';
import GeofenceUserScope from "./GeofenceUserScope";
import {EMPTY_VALUES} from "../../../../../Apis/functions";
import React from "react";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GeofenceCardBody = ({geofence, backgroundColor, dayArray}) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={`${backgroundColor} row`}>
                <div className={"col-12 p-0 border-bottom-shades-300 mb-3"}>
                    <p className={"font-color-shades-500 fs-12px ibl-font-w-600"}> {t('active_schedule')} </p>
                </div>

                <div className='col-12 p-0'>
                    <CustomDaySelector
                        dayArray={dayArray}
                        setDayArray={() => {}}
                        containerClasses={'w-auto'}
                        readonlyBorderColor={colors.shades500}
                        readonlyCheckedColor={colors.shades500}
                        readonlyBackgroundColor={colors.shades100}
                        readonlyTextColor={colors.shades500}
                        readonly={true}
                    />
                </div>
                <div className={"col-12 p-0 my-3"}>
                    <div className={'d-flex align-items-center'}>
                        <IconClockTable className='icon-color-shades-500' />
                        <p className={'font-color-shades-500 fs-14px ibl-font-w-500 ml-2'}>
                            {geofence.opening}
                            &nbsp;{t('to').toLowerCase()}&nbsp;
                            {geofence.closing}
                        </p>
                    </div>
                </div>

                <div className={"col-12 p-0 border-bottom-shades-300 mb-2"}>
                    <p className={"font-color-shades-500 fs-12px ibl-font-w-600"}>
                        {t('user_scope')}
                    </p>
                </div>

                <div className="col-12 p-0">
                    {(!geofence?.applyEmployee &&
                        !geofence?.applyContractor &&
                        !geofence?.applySupplier)
                        ? EMPTY_VALUES.DEFAULT
                        : <GeofenceUserScope geofence={geofence} />
                    }
                </div>
            </div>
        </>
    );
};
export default GeofenceCardBody;
